(function($) {
  if ($("html").hasClass("ua-ie")) {
    $(".mn-refresh .hero-banner .bg-img").imageResponsiveIe();
    $(
      ".mn-refresh .second-hero-banner .bg-img-wrap .bg-img"
    ).imageResponsiveRightIe();
  }
})(jQuery);
